/* Card photos are prepared only for the visible, active gallery. */
(function(win, doc) {
  var states = new WeakMap();
  function visible(root) {
    if (!root || !root.isConnected || doc.hidden || root.closest('[hidden], [aria-hidden="true"].Drawer')) return false;
    var style = win.getComputedStyle(root);
    if (style.visibility === 'hidden' || style.display === 'none') return false;
    var rect = root.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < win.innerHeight && rect.right > 0 && rect.left < win.innerWidth;
  }
  function request(image, priority) {
    if (!image) return;
    if (priority && image.getAttribute('fetchpriority') !== 'high') image.setAttribute('fetchpriority', priority);
    image.loading = 'eager';
    if (image.dataset.cardPhotoRequested === 'true') return;
    image.dataset.cardPhotoRequested = 'true';
    if (win.lazySizes && win.lazySizes.loader && typeof win.lazySizes.loader.unveil === 'function' && image.dataset.src) {
      win.lazySizes.loader.unveil(image);
    } else {
      if (image.dataset.srcset) image.setAttribute('srcset', image.dataset.srcset);
      if (image.dataset.src) image.src = image.dataset.src.replace('{width}', String(Math.ceil(image.getBoundingClientRect().width || 600)));
    }
  }
  function cancel(root) {
    var state = states.get(root);
    if (state && state.cleanup) state.cleanup();
    states.delete(root);
  }
  function prepare(root, slides, index, ahead, wrap) {
    if (!visible(root) || !slides.length) return;
    index = Math.min(slides.length - 1, Math.max(0, index));
    var selected = slides[index].querySelector('img');
    var old = states.get(root);
    if (old && old.selected === selected && old.index === index && old.ahead === ahead && (old.cleanup || old.warmed)) return;
    cancel(root);
    var state = { selected: selected, index: index, ahead: ahead };
    states.set(root, state);
    function neighbours() {
      if (state.cleanup) { state.cleanup(); state.cleanup = null; }
      if (states.get(root) !== state || !visible(root)) return;
      state.warmed = true;
      if (!ahead) return;
      var connection = win.navigator.connection || win.navigator.mozConnection || win.navigator.webkitConnection;
      var restricted = connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ''));
      var offsets = restricted ? [1] : [1, 2, -1];
      var seen = new Set([index]);
      offsets.forEach(function(offset) {
        if (offset < 0 && index === 0) return;
        var next = index + offset;
        if (wrap) next = (next + slides.length) % slides.length;
        if (next < 0 || next >= slides.length || seen.has(next)) return;
        seen.add(next);
        request(slides[next].querySelector('img'), 'low');
      });
    }
    if (!selected) { neighbours(); return; }
    request(selected, 'auto');
    if (selected.complete && (selected.naturalWidth > 0 || /^(?!data:).+/.test(selected.getAttribute('src') || ''))) { neighbours(); return; }
    selected.addEventListener('load', neighbours, {once:true});
    selected.addEventListener('error', neighbours, {once:true});
    state.cleanup = function() {
      selected.removeEventListener('load', neighbours);
      selected.removeEventListener('error', neighbours);
    };
  }
  win.DsrcvCardPhotos = {prepare:prepare, request:request, cancel:cancel};
})(window, document);

/* Shared mobile product-card drag/settle behaviour, matching cart media. */
(function(win, doc) {
  var query = win.matchMedia('(max-width: 1007px)');
  var states = new Map();
  var gestures = new Map();
  var restoreQueue = new Set();
  var restoreFrame = null;
  function cancelDesktopQueue() {
    if (restoreFrame !== null) win.cancelAnimationFrame(restoreFrame);
    restoreFrame = null;
    restoreQueue.clear();
  }
  function queueDesktop(ready) {
    ready.forEach(function(state) { if (state.desktopDeferred) restoreQueue.add(state); });
    if (restoreFrame !== null || !restoreQueue.size) return;
    function next() {
      restoreFrame = null;
      if (query.matches) { restoreQueue.clear(); return; }
      var state = restoreQueue.values().next().value;
      restoreQueue.delete(state);
      if (state && state.desktopDeferred && states.get(state.node) === state) restoreDesktop([state], true);
      if (restoreQueue.size && restoreFrame === null) restoreFrame = win.requestAnimationFrame(next);
    }
    // Let the resized native layout paint before starting desktop measurements.
    restoreFrame = win.requestAnimationFrame(function() { restoreFrame = win.requestAnimationFrame(next); });
  }
  var desktopObserver = win.IntersectionObserver && new win.IntersectionObserver(function(entries) {
    if (query.matches) return;
    var ready = entries.filter(function(entry) { return entry.isIntersecting; }).map(function(entry) { return states.get(entry.target); }).filter(function(state) { return state && state.desktopDeferred && state.autoDesktop(); });
    queueDesktop(ready);
  }, { rootMargin: '200px' });
  function restoreDesktop(ready, notify) {
    var focused = doc.activeElement;
    var restores = ready.map(function(state) { return state.destroy(true); });
    restores.forEach(function(restore) { restore.resetScroll(); });
    restores.forEach(function(restore) { restore.activate(); });
    if (notify && restores.some(function(restore) { return restore.needsInit; })) {
      doc.dispatchEvent(new CustomEvent('dsrcv:mobile-media-change'));
      restores.forEach(function(restore) { restore.finishInit(); });
    }
    if (focused && focused.isConnected && doc.activeElement !== focused && ready.some(function(state) { return state.node.contains(focused); })) focused.focus({ preventScroll: true });
    return restores;
  }
  var lastModelMode = !!(doc.body && doc.body.classList.contains('model-image-active'));
  var viewStates = new WeakMap();
  var viewVersion = 0;
  function bind(node) {
    if (!node) return false;
    if (!query.matches) return !!(states.get(node) && states.get(node).desktopDeferred);
    if (states.has(node)) return true;
    var cells = Array.from(node.querySelectorAll('.Carousel__Cell'));
    if (cells.length < 2) return false;
    var instance = win.Flickity && typeof win.Flickity.data === 'function' && win.Flickity.data(node);
    var focused = doc.activeElement;
    var desktopIndex = instance ? instance.selectedIndex : Number(node.dataset.nativeSearchSelectedIndex);
    // Preserve desktop hooks on their original instance across breakpoints.
    var suspendedInstance = instance && typeof instance.deactivate === 'function' && typeof instance.activate === 'function' ? instance : null;
    if (suspendedInstance) suspendedInstance.deactivate();
    else if (instance && instance.destroy) instance.destroy();
    var originalStyle = node.getAttribute('style');
    var originalCellStyles = cells.map(function(cell) { return cell.getAttribute('style'); });
    if (!suspendedInstance) {
      node.productCardCarousel = null;
      node.buyItWithCarousel = null;
      delete node.dataset.productCardBound;
    }
    node.replaceChildren.apply(node, cells);
    node.classList.remove('flickity-enabled', 'is-draggable');
    node.classList.add('MobileProductMedia');
    node.dataset.mobileMediaBound = 'true';
    var wrapper = node.closest('.ProductItem__ImageCarouselWrapper') || node;
    var root = node.closest('.product-image-container-main');
    var modelImage = root && root.querySelector('.model-image-container img');
    var progress = wrapper.querySelector('[data-product-card-progress], [data-buy-it-with-progress], [data-buy-it-with-carousel-progress]');
    var controller = new AbortController();
    var options = { signal: controller.signal };
    var start = null;
    var dragged = false;
    var blockedUntil = 0;
    var initialIndexText = node.getAttribute('data-product-card-initial-index');
    var initialIndex = initialIndexText !== null && /^\d+$/.test(initialIndexText) ? Number(initialIndexText) : null;
    if (!Number.isSafeInteger(initialIndex) || initialIndex >= cells.length) initialIndex = null;
    var currentIndex = 0;
    var settleTarget = null;
    var syncedIndex = -1;
    var syncedGestureCell = null;
    var cellVideos = cells.map(function(cell) { return Array.from(cell.querySelectorAll('video')); });
    var pendingVideos = new WeakSet();
    var frame = null;
    var observer;
    var visibilityObserver;
    var desktopDeferred = false;
    var hasPhotoIntent = false;
    var cancelSelectionWait = null;
    var pendingPhotoTarget = null;
    var selectionRequest = 0;
    function cancelPendingSelection() {
      selectionRequest += 1;
      pendingPhotoTarget = null;
      if (cancelSelectionWait) cancelSelectionWait();
      cancelSelectionWait = null;
    }
    var decodedPhotos = new WeakMap();
    function decodePhoto(image) {
      var src = image.currentSrc || image.src;
      var state = decodedPhotos.get(image);
      if (!state || state.src !== src) {
        state = {src:src, ready:false};
        decodedPhotos.set(image, state);
        state.promise = image.decode().then(function() { state.ready = true; });
        state.promise.catch(function() {});
      }
      return state.promise;
    }
    function photoReady(index) {
      var image = cells[index] && cells[index].querySelector('img');
      if (!image) return true;
      if (!image.complete || image.naturalWidth < 1) return false;
      if (typeof image.decode !== 'function') return true;
      decodePhoto(image);
      return decodedPhotos.get(image).ready;
    }
    function imagePath(image) {
      if (!image) return '';
      var src = image.currentSrc || image.getAttribute('src') || image.dataset.src;
      if (!src || /^data:/.test(src)) return '';
      try { return new win.URL(src, doc.baseURI).pathname.replace(/_\d+x\d*(?:_crop_[a-z]+)?(?=\.[^.]+$)/i, ''); }
      catch (error) { return ''; }
    }
    function modelIndex() {
      var id = (modelImage.getAttribute('data-model-media-id') || '').split('/').pop();
      var path = imagePath(modelImage);
      var index = id ? cells.findIndex(function(cell) {
        return (cell.getAttribute('data-media-id') || '').split('/').pop() === id;
      }) : -1;
      if (index < 0 && path) index = cells.findIndex(function(cell) {
        return imagePath(cell.querySelector('img')) === path;
      });
      return Math.max(0, index);
    }
    function applyViewMode() {
      viewStates.set(node, {mode: doc.body.classList.contains('model-image-active'), version: viewVersion});
      cancelPendingSelection();
      if (root) delete root.dataset.productCardSwipingMedia;
      if (modelImage) {
        currentIndex = doc.body.classList.contains('model-image-active') ? modelIndex() : 0;
        select(currentIndex, true, false);
      }
      if (desktopDeferred && !query.matches) renderSelection(true);
      else sync();
    }
    function point(event) {
      var touches = event.changedTouches && event.changedTouches.length ? event.changedTouches : event.touches;
      if (!touches) return event;
      if (start && start.touchId !== undefined) {
        return Array.from(touches).find(function(touch) { return touch.identifier === start.touchId; }) || null;
      }
      return touches[0] || null;
    }
    function warm(index) {
      hasPhotoIntent = true;
      win.DsrcvCardPhotos.prepare(node, cells, index, true, false);
    }
    function sync(force) {
      if (desktopDeferred && !query.matches) return;
      if (frame) win.cancelAnimationFrame(frame);
      frame = null;
      if (!node.clientWidth) return;
      currentIndex = Math.min(cells.length - 1, Math.max(0, Math.round(node.scrollLeft / Math.max(node.clientWidth, 1))));
      if (settleTarget !== null && Math.abs(node.scrollLeft - settleTarget * node.clientWidth) <= 1) {
        settleTarget = null;
        node.classList.remove('is-settling');
      }
      renderSelection(force);
    }
    function renderSelection(force) {
      var gestureCell = start && start.cell;
      if (force !== true && currentIndex === syncedIndex && gestureCell === syncedGestureCell) return;
      syncedIndex = currentIndex;
      syncedGestureCell = gestureCell;
      var deferred = desktopDeferred && !query.matches;
      if (hasPhotoIntent && !deferred) warm(currentIndex);
      var rect = !deferred && cellVideos.some(function(videos) { return videos.length; }) ? node.getBoundingClientRect() : null;
      node.dataset.nativeSearchSelectedIndex = String(currentIndex);
      cells.forEach(function(cell, i) {
        var active = i === currentIndex;
        cell.classList.toggle('is-selected', active);
        // Keep the original touch/focus target available until the gesture ends.
        var gestureTarget = start && cell === start.cell;
        cell.setAttribute('aria-hidden', active || gestureTarget ? 'false' : 'true');
        cell.inert = !active && !gestureTarget;
        cellVideos[i].forEach(function(video) {
          if (!active || deferred || doc.hidden || !rect.width || !rect.height || rect.bottom <= 0 || rect.top >= win.innerHeight) {
            video.pause(); return;
          }
          var src = video.getAttribute('data-video-src');
          if (src && !video.getAttribute('src')) video.src = src;
          video.querySelectorAll('source[data-src]').forEach(function(s) { if (!s.src) s.src = s.dataset.src; });
          video.muted = true;
          if (video.paused && !pendingVideos.has(video)) {
            pendingVideos.add(video);
            var play = video.play();
            if (play && play.catch) play.catch(function() {}).finally(function() { pendingVideos.delete(video); });
            else pendingVideos.delete(video);
          }
        });
      });
      if (progress) {
        progress.hidden = false;
        progress.style.setProperty('--product-card-progress-count', cells.length);
        progress.style.setProperty('--product-card-progress-index', currentIndex);
        progress.setAttribute('data-product-card-progress-count', cells.length);
        progress.setAttribute('data-product-card-progress-index', currentIndex);
      }
    }
    function select(index, instant, hydrate) {
      index = Math.max(0, Math.min(cells.length - 1, index));
      cancelPendingSelection();
      if (hydrate !== false && hasPhotoIntent) {
        warm(index);
        if (!photoReady(index)) {
          pendingPhotoTarget = index;
          var image = cells[index].querySelector('img');
          var token = selectionRequest;
          function loaded() {
            if (!image.complete || image.naturalWidth < 1) return;
            image.removeEventListener('load', loaded);
            var ready = typeof image.decode === 'function' ? decodePhoto(image) : Promise.resolve();
            ready.then(function() {
              if (token !== selectionRequest || !node.isConnected || !query.matches) return;
              if (root) root.dataset.productCardSwipingMedia = 'true';
              select(index, true);
            }, cancelWait);
          }
          function cancelWait() { if (token === selectionRequest) cancelPendingSelection(); }
          image.addEventListener('load', loaded);
          image.addEventListener('error', cancelWait, {once:true});
          cancelSelectionWait = function() {
            image.removeEventListener('load', loaded);
            image.removeEventListener('error', cancelWait);
          };
          // Stay on the last visible photo while a cold destination loads.
          node.classList.remove('is-settling');
          settleTarget = null;
          node.scrollTo({left: currentIndex * node.clientWidth, behavior: 'instant'});
          loaded();
          return;
        }
        if (root) root.dataset.productCardSwipingMedia = 'true';
      }
      var immediate = instant || win.matchMedia('(prefers-reduced-motion: reduce)').matches;
      settleTarget = immediate ? null : index;
      if (immediate) currentIndex = index;
      // Let the explicit settle own its destination, without an intermediate snap.
      node.classList.toggle('is-settling', !immediate);
      node.scrollTo({ left: index * node.clientWidth, behavior: immediate ? 'instant' : 'smooth' });
    }
    function clearGesture(keepSnapDisabled) {
      if (start && start.pointerId !== undefined) {
        gestures.delete(start.pointerId);
        if (node.hasPointerCapture && node.hasPointerCapture(start.pointerId)) {
          try { node.releasePointerCapture(start.pointerId); } catch (error) {}
        }
      }
      if (keepSnapDisabled) node.classList.add('is-settling');
      start = null; node.classList.remove('is-dragging');
    }
    function reset(keepSnapDisabled) {
      clearGesture(keepSnapDisabled);
      sync();
    }
    function down(event) {
      // Use the touch stream on phones; mouse/pen keep pointer capture/routing.
      if (event.pointerType === 'touch' && 'ontouchstart' in win) return;
      if (event.touches && event.touches.length > 1) {
        if (start && start.touchId !== undefined) reset();
        return;
      }
      if (event.button && event.button !== 0 || start) return;
      cancelPendingSelection();
      // A quick second swipe starts from the last requested photo, not halfway
      // through the browser's previous smooth-scroll animation.
      if (settleTarget !== null) select(settleTarget, true, false);
      // Read the actual position, including a previous swipe that just settled.
      if (modelImage && root.dataset.productCardSwipingMedia !== 'true') applyViewMode();
      else sync();
      var p = point(event);
      if (!p) return;
      start = { x: p.clientX, y: p.clientY, left: node.scrollLeft, index: currentIndex, pointerId: event.pointerId, touchId: p.identifier, cell: event.target.closest('.Carousel__Cell') || cells[currentIndex] };
      dragged = false;
      sync();
      node.dispatchEvent(new CustomEvent('product-card:manual-media-intent', { bubbles: true }));
      if (event.pointerId !== undefined) gestures.set(event.pointerId, { move: move, end: end, cancel: cancel });
    }
    function move(event) {
      if (!start || event.pointerId !== start.pointerId) return;
      if (event.touches && event.touches.length > 1) { reset(); return; }
      var p = point(event);
      if (!p) return;
      var dx = p.clientX - start.x, dy = p.clientY - start.y;
      if (!dragged && Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) { reset(); return; }
      if (!dragged && Math.abs(dx) >= 12 && Math.abs(dx) > Math.abs(dy) * 1.1) {
        dragged = true;
        warm(currentIndex);
        // Capturing on pointerdown would redirect a normal link tap to the track.
        if (event.pointerId !== undefined && node.setPointerCapture) {
          try { node.setPointerCapture(event.pointerId); } catch (error) {}
        }
      }
      if (!dragged) return;
      var target = Math.max(0, Math.min(cells.length - 1, start.index + (dx < 0 ? 1 : -1)));
      if (!photoReady(start.index) || !photoReady(target)) {
        win.DsrcvCardPhotos.request(cells[target].querySelector('img'));
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
        return;
      }
      node.classList.add('is-dragging');
      if (root) root.dataset.productCardSwipingMedia = 'true';
      if (event.cancelable) event.preventDefault();
      event.stopPropagation();
      node.scrollLeft = start.left - dx;
      scheduleSync();
    }
    function end(event) {
      if (!start || event.pointerId !== start.pointerId) return;
      var p = point(event);
      if (!p) return;
      var dx = p.clientX - start.x;
      sync();
      var target = dragged && Math.abs(dx) >= 34 ? start.index + (dx < 0 ? 1 : -1) : currentIndex;
      if (dragged) {
        blockedUntil = Date.now() + 500;
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
      }
      var didDrag = dragged;
      reset(didDrag);
      if (didDrag) select(target);
    }
    function cancel(event) {
      if (!start || event.pointerId !== start.pointerId) return;
      if (start.touchId !== undefined && !point(event)) return;
      sync();
      var didDrag = dragged;
      var target = currentIndex;
      if (didDrag) {
        blockedUntil = Date.now() + 500;
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
      }
      reset(didDrag);
      if (didDrag) select(target);
    }
    function listen(name, fn, passive) { node.addEventListener(name, fn, { signal: controller.signal, capture: true, passive: passive }); }
    // Linked photos must stay with the gallery rather than starting a native drag.
    listen('dragstart', function(event) { event.preventDefault(); }, false);
    if (win.PointerEvent) {
      listen('pointerdown', down, true);
    }
    listen('touchstart', down, true); listen('touchmove', move, false); listen('touchend', end, false); listen('touchcancel', cancel, false);
    node.addEventListener('product-card:media-enhanced', function() {
      // A desktop media request may complete after crossing into mobile.
      // Adopt appended slides without cancelling the shopper's current gesture.
      Array.from(node.querySelectorAll('.Carousel__Cell')).forEach(function(cell) {
        if (cells.indexOf(cell) >= 0) return;
        originalCellStyles.push(cell.getAttribute('style'));
        cells.push(cell);
        cellVideos.push(Array.from(cell.querySelectorAll('video')));
      });
      sync(true);
    }, options);
    node.addEventListener('product-card:view-change', function() {
      reset();
      applyViewMode();
    }, options);
    function scheduleSync() {
      if (!frame) frame = win.requestAnimationFrame(function() { frame = null; sync(); });
    }
    doc.addEventListener('visibilitychange', function() { sync(true); }, options);
    node.addEventListener('scroll', scheduleSync, { passive: true, signal: controller.signal });
    wrapper.addEventListener('click', function(event) {
      if (Date.now() < blockedUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, { capture: true, signal: controller.signal });
    node.addEventListener('keydown', function(event) {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        hasPhotoIntent = true;
        event.preventDefault(); select(currentIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }
    }, options);
    var nav = root && Array.from(root.querySelectorAll('[data-product-card-nav]')).find(function(element) {
      return element.getAttribute('data-product-card-nav') === node.id;
    });
    if (nav) nav.addEventListener('click', function(event) {
      var button = event.target.closest('button[data-direction]');
      if (!button || !nav.contains(button) || button.disabled) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      sync();
      hasPhotoIntent = true;
      var direction = button.getAttribute('data-direction') === 'prev' ? -1 : 1;
      var fromIndex = pendingPhotoTarget !== null ? pendingPhotoTarget : settleTarget === null ? currentIndex : settleTarget;
      select((fromIndex + direction + cells.length) % cells.length);
    }, {capture: true, signal: controller.signal});
    if (win.ResizeObserver) {
      var width = node.clientWidth;
      observer = new ResizeObserver(function() {
        if (node.clientWidth === width) return;
        width = node.clientWidth;
        if (desktopDeferred && !query.matches) {
          node.scrollTo({ left: currentIndex * width, behavior: 'instant' });
          return;
        }
        select(currentIndex, true);
      });
      observer.observe(node);
    }
    if (win.IntersectionObserver) {
      visibilityObserver = new win.IntersectionObserver(function() { sync(true); }, { threshold: 0.1 });
      visibilityObserver.observe(node);
    }
    states.set(node, { node: node, viewChange: applyViewMode,
      selectedVideo: function() { return cellVideos[settleTarget === null ? currentIndex : settleTarget].length > 0; },
      autoDesktop: function() { return !!node.closest('.NativeSearchPanel') || this.selectedVideo(); },
      get desktopDeferred() { return desktopDeferred; },
      deferDesktop: function(desktopWidth) {
        currentIndex = settleTarget === null ? currentIndex : settleTarget;
        settleTarget = null;
        cancelPendingSelection(); clearGesture();
        cellVideos.forEach(function(videos) { videos.forEach(function(video) { video.pause(); }); });
        if (frame) win.cancelAnimationFrame(frame);
        frame = null;
        desktopDeferred = true;
        node.classList.remove('is-settling');
        renderSelection();
        desktopObserver.observe(node);
        return function() {
          if (desktopWidth > 0) node.scrollTo({ left: currentIndex * desktopWidth, behavior: 'instant' });
        };
      },
      resumeMobile: function() {
        if (!desktopDeferred) return;
        desktopDeferred = false;
        desktopObserver.unobserve(node);
        select(currentIndex, true, false);
      },
      destroy: function(deferRestore) {
      var restoreIndex = settleTarget === null ? currentIndex : settleTarget;
      cancelPendingSelection();
      win.DsrcvCardPhotos.cancel(node);
      // The breakpoint has already changed widths; retain the last mobile index.
      clearGesture(); controller.abort(); if (observer) observer.disconnect(); if (visibilityObserver) visibilityObserver.disconnect(); if (frame) win.cancelAnimationFrame(frame);
      node.querySelectorAll('video').forEach(function(video) { video.pause(); });
      node.classList.remove('MobileProductMedia', 'is-dragging', 'is-settling'); delete node.dataset.mobileMediaBound;
      if (originalStyle === null) node.removeAttribute('style'); else node.setAttribute('style', originalStyle);
      cells.forEach(function(cell, i) {
        cell.inert = false; cell.removeAttribute('aria-hidden');
        if (originalCellStyles[i] === null) cell.removeAttribute('style'); else cell.setAttribute('style', originalCellStyles[i]);
      });
      restoreQueue.delete(states.get(node));
      states.delete(node);
      if (!restoreQueue.size && restoreFrame !== null) { win.cancelAnimationFrame(restoreFrame); restoreFrame = null; }
      if (desktopObserver) desktopObserver.unobserve(node);
      var restore = {
        needsInit: !suspendedInstance,
        finishInit: function() {
          if (suspendedInstance || !node.isConnected || query.matches) return;
          var created = win.Flickity && win.Flickity.data(node);
          if (created && created.isActive) created.select(restoreIndex, false, true);
        },
        resetScroll: function() { node.scrollLeft = 0; },
        activate: function() {
          if (suspendedInstance && node.isConnected && !query.matches) {
            suspendedInstance.activate();
            suspendedInstance.select(restoreIndex, false, true);
          }
        }
      };
      if (deferRestore) return restore;
      restore.resetScroll();
      restore.activate();
    } });
    var modelMode = doc.body.classList.contains('model-image-active');
    var previousView = viewStates.get(node);
    var unchangedView = previousView && previousView.mode === modelMode && previousView.version === viewVersion;
    var manualDesktop = !previousView && modelMode === lastModelMode && (node.dataset.productCardManualMediaIntent === 'true' || root && root.dataset.productCardSwipingMedia === 'true');
    if ((unchangedView || manualDesktop) && Number.isFinite(desktopIndex)) {
      currentIndex = Math.max(0, Math.min(cells.length - 1, desktopIndex));
      viewStates.set(node, {mode: modelMode, version: viewVersion});
      select(currentIndex, true, false);
      sync();
    } else if (initialIndex !== null && !modelImage) {
      viewStates.set(node, {mode: modelMode, version: viewVersion});
      select(initialIndex, true, false);
      sync();
    } else applyViewMode();
    if (focused && focused.isConnected && node.contains(focused) && doc.activeElement !== focused) focused.focus({preventScroll:true});
    return true;
  }
  // One shared pointer route keeps a held gesture working across card boundaries.
  ['pointermove', 'pointerup', 'pointercancel'].forEach(function(type) {
    win.addEventListener(type, function(event) {
      var gesture = gestures.get(event.pointerId);
      if (gesture) gesture[type === 'pointermove' ? 'move' : type === 'pointerup' ? 'end' : 'cancel'](event);
    }, { capture: true, passive: false });
  });
  win.DsrcvMobileProductMedia = { bind: bind, enabled: function() { return query.matches; } };
  query.addEventListener('change', function() {
    var focused = doc.activeElement;
    if (!query.matches) {
      var ready = [];
      var later = [];
      var nearby = [];
      // Keep the native layout until each desktop gallery gets its own frame.
      states.forEach(function(state, node) {
        var rect = desktopObserver && !win.navigator.maxTouchPoints && node.getBoundingClientRect();
        var focusRoot = node.closest('.product-image-container-main') || node.closest('.ProductItem__ImageCarouselWrapper') || node;
        var engaged = focusRoot.contains(doc.activeElement) || focusRoot.matches(':hover');
        var near = rect && rect.width && rect.height && rect.bottom >= -200 && rect.top <= win.innerHeight + 200 && rect.right >= -200 && rect.left <= win.innerWidth + 200;
        if (!rect || engaged || (near && state.selectedVideo())) ready.push(state);
        else {
          later.push({ state: state, width: node.clientWidth });
          if (near && state.autoDesktop()) nearby.push(state);
        }
      });
      var align = later.map(function(item) { return item.state.deferDesktop(item.width); });
      // Scroll alignment can flush layout, so finish every metadata write first.
      align.forEach(function(apply) { apply(); });
      var restored = restoreDesktop(ready);
      queueDesktop(nearby);
    } else {
      cancelDesktopQueue();
      states.forEach(function(state) { state.resumeMobile(); });
    }
    doc.dispatchEvent(new CustomEvent('dsrcv:mobile-media-change'));
    if (restored) {
      restored.forEach(function(restore) { restore.finishInit(); });
      if (focused && focused.isConnected && doc.activeElement !== focused && ready.some(function(state) { return state.node.contains(focused); })) focused.focus({preventScroll:true});
    }
  });
  function restoreOnIntent(event) {
    if (query.matches || !event.target.closest) return;
    if (event.type === 'click' && !event.target.closest('[data-product-card-nav] button[data-direction]')) return;
    var wrapper = event.target.closest('.ProductItem__ImageCarouselWrapper, .product-image-container-main');
    var node = wrapper && wrapper.querySelector('.MobileProductMedia');
    var state = node && states.get(node);
    if (state && state.desktopDeferred) restoreDesktop([state], true);
  }
  // Restore before a gesture starts; replacing its viewport during down loses that gesture.
  ['pointerover', 'mouseover', 'focusin', 'click'].forEach(function(type) {
    doc.addEventListener(type, restoreOnIntent, { capture: true, passive: true });
  });
  new MutationObserver(function() {
    states.forEach(function(state, node) { if (!node.isConnected) state.destroy(); });
  }).observe(doc.documentElement, { childList: true, subtree: true });
  if (doc.body) new MutationObserver(function() {
    var modelMode = doc.body.classList.contains('model-image-active');
    if (modelMode === lastModelMode) return;
    lastModelMode = modelMode;
    viewVersion += 1;
    doc.querySelectorAll('[data-product-card-carousel]').forEach(function(node) {
      delete node.dataset.productCardManualMediaIntent;
      var wrapper = node.closest('.ProductItem__ImageCarouselWrapper');
      var root = node.closest('.product-image-container-main');
      if (wrapper) delete wrapper.dataset.productCardManualMediaIntent;
      if (root) delete root.dataset.productCardSwipingMedia;
    });
    states.forEach(function(state) { state.viewChange(); });
  }).observe(doc.body, { attributes: true, attributeFilter: ['class'] });
})(window, document);
